/**
 * Il bucket `documents` è privato (INB-379): i file si aprono solo con il link
 * firmato che l'API mette nelle righe che restituisce. Una riga che arriva dal
 * Realtime di Supabase porta invece il riferimento non firmato, che non apre
 * nulla: gli hook che la ricevono rileggono la lista dall'API invece di usarla
 * così com'è.
 */
export function hasDocumentFile(...values: unknown[]): boolean {
	return values.some(
		(v) =>
			(typeof v === 'string' && v.includes('/storage/v1/object/public/documents/')) ||
			(Array.isArray(v) && hasDocumentFile(...v)) ||
			(v != null && typeof v === 'object' && !Array.isArray(v) && hasDocumentFile(...Object.values(v))),
	);
}
